import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { editUsernameModalActions } from './edit-username-modal.actions';
import { map } from 'rxjs/operators';
import {profileApiActions} from "@fitup-monorepo/core/lib/state/profile/profile.actions";

@Injectable()
export class EditUsernameModalEffects {
  private readonly actions$ = inject(Actions);

  public readonly updateCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editUsernameModalActions.updateCustomer),
      map(customer => profileApiActions.updateCustomer(customer))
    )
  );
}
